import actionTypes, { WEB_PAGE_SITE_MAP_INFO } from './actionTypes'

export const siteMapInfo = payload => ({
  type: actionTypes[WEB_PAGE_SITE_MAP_INFO].pending,
  payload,
})
